import {Ad} from "./ad";
import {IframeManager} from "./iframeManager";

export class Banner extends Ad {

    constructor(context, containerId, parameters, ad) {
        super(context, containerId, parameters, ad)
    }

    build() {
        this.container.style.background = this.ad.background || 'transparent';
        this.container.style.margin = "0 auto";
        this.container.style.textAlign = "center";
        this.container.style.position = "relative";

        if (this.ad['img']) {
            this.setAdImage();
        } else if (this.ad['format'] === 'html') {
            this.setAdHtml();
        } else if (this.ad.content) {
            this.setAdContent();
        } else {
            this.setAdText();
        }

        if (this.isParallax()) {
            this.container.style.overflow = "hidden";
            let parallaxContainer = this.container.firstElementChild;
            let containerLeft = this.container.offsetLeft;
            let tmp = this.container;

            while (tmp.offsetParent) {
                tmp = tmp.offsetParent;
                containerLeft += tmp.offsetLeft;
            }

            parallaxContainer.style.position = "fixed";
            parallaxContainer.style.left = containerLeft + "px";
            parallaxContainer.style.bottom = '0';
            parallaxContainer.style.lineHeight = '0';
            parallaxContainer.style.width = this.container.clientWidth + "px";
            if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
                this.container.style.clip = "rect(auto, auto, auto, auto)";
                let containerW = this.container.clientWidth;
                this.container.style.position = "absolute";
                if (this.container.clientWidth === 0) {
                    this.container.style.width = containerW + "px";
                }
            } else {
                this. container.style.clipPath = "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)";
            }

            if (this.container.clientWidth === 0 && parseFloat(this.ad.adspaceWidth)) {
                this.container.style.width = this.ad.adspaceWidth + "px";
            }

            if (this.container.clientHeight === 0 && this.ad.adspaceHeight != '0') {
                this.container.style.height = this.ad.adspaceHeight + "px";
            }

            const the = this;
            this.context.addEventListener('scroll', function () {
                if (parallaxContainer.clientHeight !== window.innerHeight) {
                    let d, containerWindowPos, direction;
                    if (parallaxContainer.clientHeight > window.innerHeight) {
                        parallaxContainer.style.bottom = "auto";
                        parallaxContainer.style.top = "auto";
                        d = parallaxContainer.clientHeight - window.innerHeight;
                        containerWindowPos = the.container.getBoundingClientRect();
                        direction = "-";
                        if (containerWindowPos.y < 0) {
                            parallaxContainer.style.top = "0";
                        } else if (containerWindowPos.bottom > window.innerHeight) {
                            parallaxContainer.style.bottom = "0";
                        } else {
                            parallaxContainer.style.top = "-" + (containerWindowPos.y / (window.innerHeight - the.container.clientHeight) * d) + "px";
                        }

                    } else if (parallaxContainer.clientHeight < window.innerHeight) {
                        parallaxContainer.style.bottom = "auto";
                        parallaxContainer.style.top = "auto";
                        d = window.innerHeight - parallaxContainer.clientHeight;
                        containerWindowPos = the.container.getBoundingClientRect();
                        direction = "+";
                    }

                    if (containerWindowPos.y < 0) {
                        parallaxContainer.style.top = "0";
                    } else if (containerWindowPos.bottom > window.innerHeight) {
                        parallaxContainer.style.bottom = "0";
                    } else {
                        parallaxContainer.style.top = direction + (containerWindowPos.y / (window.innerHeight - the.container.clientHeight) * d) + "px";
                    }
                }
            });
        }
    }

    setAdImage() {
        let link = document.createElement('link');
        link.href = this.ad.url;
        link.target = this.parameters.target;

        let image = new Image();
        image.src = this.ad['img'];
        image.width = this.ad['adspaceWidth'] || this.parameters['img_width'] || "";
        image.height = this.ad['adspaceHeight'] || this.parameters['img_height'] || "";
        link.innerHTML = image.outerHTML;
        let content = this.buildAdChoice() + link.outerHTML;
        if (this.isParallax()) {
            content = "<div>" + content + "</div>";
        }

        this.container.innerHTML = content;
    }

    setAdHtml() {
        this.container.style.display = 'none';
        this.iframeManager = new IframeManager(this);
        let iframe = this.iframeManager.build();
        let content;

        if (this.isParallax()) {
            content = document.createElement("div");
            content.innerHTML = this.buildAdChoice();
            content.appendChild(iframe);
        } else {
            this.container.innerHTML = this.buildAdChoice();
            content = iframe;
        }

        if (this.ad['iframe']) {
            iframe.setAttribute('src', d.iframe);
            this.container.appendChild(content);
        } else {
            this.container.appendChild(content);
            this.iframeManager.addContent(this.ad.content);
        }

        this.container.style.display = 'block';
    }

    setAdContent() {
        if (parseFloat(this.ad['adspaceWidth'])) {
            this.container.style.width = this.ad['adspaceWidth'] + "px";
        }

        if (parseFloat(this.ad['adspaceHeight'])) {
            this.container.style.height = this.ad['adspaceHeight'] + "px";
        }

        this.container.innerHTML = this.buildAdChoice();
        let content = this.ad.content;
        if (this.isParallax()) {
            content = "<div>" + content + "</div>";
        }

        this.workmedcont(content, this.container);
    }

    setAdText() {
        let link = document.createElement('link');
        link.href = this.ad.url;
        link.target = this.parameters.target;
        link.innerHTML = this.ad.text;
        this.container.innerHTML = this.buildAdChoice() + link.outerHTML;
    }

}
